module.exports = __webpack_public_path__ + "static/media/hi-IN.f892b6cb.md";